export const USERNAME_REGEX = /^(?=.{3,30}$)[a-z0-9][a-z0-9._-]*$/;

/**
 * Normalizes an identifier by trimming and converting to lowercase
 */
export function normalizeIdentifier(value: string): string {
  return value.trim().toLowerCase();
}

/**
 * Checks if a string is a valid email format
 */
export function isEmail(value: string): boolean {
  // Simple email validation - matches the pattern used in emailFormValidator
  return /^\S+@\S+$/.test(value);
}

/**
 * Checks if a string is a valid username format
 */
export function isUsername(value: string): boolean {
  return USERNAME_REGEX.test(value);
}

